/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Hero from "../components/common_components/Hero";
import HomeBlog from "../components/pageComponents/Home/HomeBlog";
import Playbook from "../components/pageComponents/Home/Playbook";
import WhatIDo from "../components/pageComponents/Home/WhatIDo";
import Halment from "../faetures/Halment";
import Popup from "../faetures/Popup";
import badge from "../images/badge-final-2.svg";
import heroImage from "../images/service-showcase-9.webp";
import Layout from "../layout/Layout";

function Home() {
  const [show , setShow] =useState(false) 


  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(!show);
    }, 10000);
    return () => clearTimeout(timer);
  }, []);
  






  return (
    <>
     <Halment title="Home" />
      <div className="home_popup_relative">
        <Layout>
          <Hero
            main="Software is still eating the world."
            badge={badge}
            heroImage={heroImage}
            link="/service"
            smallText="I help you stay alive and ahead"
            outlineButton="See all Services"
            description="Today there isn't any business not shaken by software. 'Digital Transformation is the buzz. Every offline business has an online competitor. It is a matter of survival but also a matter of staying ahead of competition. It is our mission to help you stay ahead in the race to digitalization."
          />
          <div className="margin_container">
            <WhatIDo />
         {
          show &&    <Popup/>
         }
            <HomeBlog />
            <Playbook />
          </div>
        </Layout>
      </div>
    </>
  );
}

export default Home;
